module.exports = __webpack_public_path__ + "media/svg-new/designer2-4ef3ee14.svg";